var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgWallettransfer = function SvgWallettransfer(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.468 3.85a.511.511 0 0 1 0-1.02h14.298a.511.511 0 0 1 0 1.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.49 10.66a1.534 1.534 0 0 1-1.533-1.532v-.77a.511.511 0 0 1 1.022 0v.77c0 .281.229.51.51.51h12.256c.281 0 .51-.229.51-.51v-7.15c0-.281-.229-.51-.51-.51H3.489c-.281 0-.51.229-.51.51v2.754a.511.511 0 0 1-1.022 0V1.98c0-.845.688-1.532 1.532-1.532h12.256c.844 0 1.532.687 1.532 1.532v7.149c0 .844-.688 1.531-1.532 1.531z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.51 7.936v-.851h2.043v.851zm2.213 1.021c.47 0 .851-.382.851-.85V6.914a.852.852 0 0 0-.85-.851H12.34a.852.852 0 0 0-.85.85v1.192c0 .47.381.851.85.851z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.213 17.553a1.534 1.534 0 0 1-1.532-1.532v-1.22a.511.511 0 0 1 1.021 0v1.22c0 .282.23.51.51.51h12.256c.282 0 .51-.228.51-.51V8.872c0-.281-.228-.51-.51-.51h-.482a.511.511 0 0 1 0-1.022h.482c.845 0 1.532.687 1.532 1.532v7.15c0 .844-.687 1.531-1.532 1.531z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.043 14.85a.511.511 0 0 1 0-1.02h.68a.511.511 0 0 1 0 1.02z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.915 14.85a.511.511 0 0 1 0-1.02h.68a.511.511 0 0 1 0 1.02z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.51 9.979A.511.511 0 0 1 0 9.468v-.851a2.556 2.556 0 0 1 2.553-2.553h5.192a.511.511 0 0 1 0 1.02H2.553c-.845 0-1.532.688-1.532 1.533v.85c0 .282-.229.512-.51.512z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.872 15.979a.511.511 0 0 1-.51-.511v-.851a2.556 2.556 0 0 1 2.553-2.553h5.191a.511.511 0 0 1 0 1.02H3.915c-.845 0-1.532.688-1.532 1.533v.85c0 .282-.23.512-.51.512z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.552 8.447a.511.511 0 0 1-.36-.871l1-1.002-1.004-1.006-.004-.005a.511.511 0 0 1 .72-.72l.005.005 1.366 1.366a.512.512 0 0 1 0 .72L6.915 8.296a.507.507 0 0 1-.36.15z"
  })));
};

export default SvgWallettransfer;